import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { EventTicket } from '../../types';


export interface EventTicketState {
    passes: EventTicket[];
    selectedPass: EventTicket | null;
    status: 'idle' | 'loading' | 'failed';
}

const initialState: EventTicketState = {
    passes: [],
    selectedPass: null,
    status: 'loading',
};


export const EventTicketsSlice = createSlice({
  name: 'eventTickets',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    received: (state, action: PayloadAction<EventTicket[]>) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.passes = action.payload;
    },
    created: (state, action: PayloadAction<EventTicket>) => {
      state.passes.concat(action.payload);
    },
    // Use the PayloadAction type to declare the contents of `action.payload`
    deleted: (state, action: PayloadAction<EventTicket>) => {
      let index = state.passes.indexOf(action.payload)
      state.passes = state.passes.splice(index, 1);
    },
  },
});

export const { received, created, deleted } = EventTicketsSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectPasses = (state: RootState) => state.eventTickets.passes.values;

export default EventTicketsSlice.reducer;
